export default __webpack_public_path__ + "static/media/navigation-variation-tab.1c35268d.svg";